import { ContentContainer } from 'app/components/Core/ChakraContentContainer';
import { ContentContainerType } from 'types/enums';
import { ChakraEmptyList } from 'app/components/Core';
import { ReleaseType } from 'types/releases';
import { ReleaseActions } from '../ReleaseActions';

interface VersionCreditsListEmptyStateProps {
  setIsOpen: (state: boolean) => void;
  isOpen: boolean;
  syncState: boolean;
  handleSync: () => void;
  releaseType: ReleaseType;
}

export const VersionCreditsListEmptyState = ({
  syncState,
  releaseType,
}: VersionCreditsListEmptyStateProps) => {
  return (
    <ContentContainer type={ContentContainerType.LIST}>
      <ReleaseActions tab="contributions" syncState={syncState} />
      <ContentContainer
        type={ContentContainerType.APP}
        isViewContent
        centerContent
        pt={0}
        pb={24}
        height="100%"
      >
        {releaseType === ReleaseType.LABEL_V2 ? (
          <ChakraEmptyList
            data-testid="missing-list-message"
            titleSx={{ color: 'textError' }}
            title="Credits are required in order to make a release."
            primaryText="At least one non-songwriter credit is required to make a release. You can add credits in the Song and then Sync for this release and all information will be fetched."
          />
        ) : (
          <ChakraEmptyList
            title="No credits for this Song."
            primaryText="You can add credits in the Song and then Sync for this release and all information will be fetched."
          />
        )}
      </ContentContainer>
    </ContentContainer>
  );
};
